export default "__VITE_ASSET__DOFA6RUM__"